<template>
  <v-card flat class="mt-1 pa-4">
    <v-card outlined class="mt-4" v-for="SBlock in speech" :key="'sblock-id-' + SBlock.type.id">
      <v-card-title>{{ SBlock.type.name }}</v-card-title>
      <template v-for="(SStruct, index) in SBlock.struct">
        <v-card-subtitle
          :key="'sstruct-index-' + index">
          {{ SStruct.type.name }}: <strong>{{ SStruct.timing }}</strong>
        </v-card-subtitle>
        <v-card-text class="ml-4 mr-4" :key="'sstruct-index-' + index" >
          <span v-html="SStruct.text"></span>
        </v-card-text>
      </template>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'Speech',
  props: {
    speech: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
